<template>
  <div id="side-wrapper" :class="{'side-wrapper': true, 'editor-mode': activeTab === CODING_TABS.EDITOR}">
    <slot></slot>
    <div :class="{
      'side-top-wrapper': true
     }">
      <app-sidebar-navigation
          :activeTab="activeTab"
          :activeOrganization="activeOrganization"
          :missingCategories.sync="missingCategories"
          @setActiveTab="$emit('setActiveTab', $event)"
          @onPublishAnalysisClick="$emit('onPublishAnalysisClick')"
      />
      <div id="editor-summary" v-if="showSummary">
        <app-top-line-summary
          @update="callUpdateArticleTopLine"
        />
      </div>
    </div>
    <div :class="{'side-bottom-wrapper': true, 'show-summary': showSummary }">
      <app-top-line v-if="activeTab === CODING_TABS.TOPLINE && articleTopLine.data"
                    :article="articleTopLine.data"
                    @updateArticleTopLine="$emit('updateArticleTopLine', $event)"
                    @refreshArticleTopLineMetrics="$emit('refreshArticleTopLineMetrics', $event)"
                    @updateTranslations="$emit('updateTranslations', $event)"
                    @searchAuthors="$emit('searchAuthors', $event)"
      />
      <app-sources v-if="activeTab === CODING_TABS.SOURCES"
                   ref="sources"
                   :activeOrganization="activeOrganizationObject"
                   @addMentionTag="$emit('addMentionTag', $event)"
                   @deleteSourceQuote="$emit('deleteSourceQuote', $event)"
                   @setActiveSource="$emit('setActiveSource', $event)"
                   @setActiveQuoteIndex="$emit('setActiveQuoteIndex', $event)"

      />
      <app-outlets v-if="activeTab === CODING_TABS.OUTLETS"
                   :activeOutlet="articleOutlet"
                   @saveArticleOutlet="$emit('saveArticleOutlet', $event)"
      />
      <app-result-panel v-if="activeTab === CODING_TABS.EDITOR"
                        :articleMentions="articleMentions"
                        :contentMentions="contentMentions"
                        :activeOrganization="activeOrganization"
                        :briefMappings="briefMappings"
                        :keysPressed="keysPressed"
                        @toggleOrganizationsTagMenu="toggleOrganizationsTagMenu"
                        @toggleCategoriesTagMenu="toggleCategoriesTagMenu"
                        @setActiveOrganization="$emit('setActiveOrganization', $event)"
                        @deleteMentionTag="callDeleteMentionTag"
                        @deleteOrganizationMention="$emit('deleteOrganizationMention', $event)"
                        @deleteRelationMentionTag="$emit('deleteRelationMentionTag', $event)"
                        @updateMentionSentiment="$emit('updateMentionSentiment', $event)"
                        @recordAction="$emit('recordAction', $event)"
                        @showRelationTagMenu="$emit('showRelationTagMenu', $event)"
                        @cloneOrganizationMentions="$emit('cloneOrganizationMentions', $event)"
      />

      <app-history v-if="activeTab === CODING_TABS.HISTORY"
      
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';

import SidebarNavigation from './sidebar_navigation';
import TopLineSummary from './top_line_summary';
import ResultPanel from './result_panel';
import TopLine from './top_line';
import Sources from './sources';
import Outlets from './outlets';
import History from './history';

import { CODING_TABS, TAG_TYPE } from '../../config/const';
import Editor from '../../helpers/editor';

export default {
  props: {
    isTagsMenuPinned: Boolean,
    isTagsMenuOpen: Boolean,
    isTagsMenuOverflow: Object,
    currentTagsType: String,
    articleMentions: {
      type: Array,
      default: () => []
    },
    contentMentions: {
      type: Array,
      default: () => []
    },
    activeOrganization: String,
    briefMappings: Object,
    articleTopLine: Object,
    activeTab: {
      type: String,
      required: true
    },
    isClipPublished: {
      type: Boolean,
      default: false
    },
    articleOutlet: {
      type: Object,
      default: () => {}
    },
    keysPressed: {
      type: Array,
      default: () => []
    },
    missingCategories: {
      type: [Object, null],
      required: false,
      default: null,
    }
  },
  components: {
    'app-sidebar-navigation': SidebarNavigation,
    'app-top-line-summary': TopLineSummary,
    'app-result-panel': ResultPanel,
    'app-top-line': TopLine,
    'app-sources': Sources,
    'app-outlets': Outlets,
    'app-history': History
  },
  computed: {
    ...mapState('editorProjectSettings', [
      'editorProjectSettings'
    ]),
    ...mapState({
      projectSetupGeneral: state => state?.projectSetup?.projectSetup?.data?.general
    }),
    projectId() {
      return this.$route.params.project_id;
    },
    activeOrganizationObject () {
      return _.cloneDeep(this.contentMentions.find(mention => Editor.stringToClass(mention.name) === this.activeOrganization));
    },
    showSummary () {
      return this.activeTab === CODING_TABS.EDITOR && this.editorProjectSettings.data && this.editorProjectSettings.data.show_summary;
    },
    isUseOrgWithCategory() { return this.projectSetupGeneral?.organizations_with_category },
  },
  methods: {
    callUpdateArticleTopLine() {
      this.$emit('updateArticleTopLine', { topLineModel: { summary: this.articleTopLine.data.summary } });
    },
    refreshArticleTopLineMetrics() {
      this.$emit('refreshArticleTopLineMetrics');
    },
    callDeleteMentionTag({ tag, organization }) {
      this.$emit('deleteMentionTag', { tag, organization });
    },
    toggleOrganizationsTagMenu () {
      let currentTagsType;
      let isTagsMenuOpen;
      let tagKey;
      if(this.currentTagsType === TAG_TYPE.ORGANIZATION && !this.isTagsMenuPinned) {
          currentTagsType = '';
          isTagsMenuOpen = false;
      }
      else {
        // if organization with category mode start the organization side menu with the config step's determined category
          currentTagsType = this.isUseOrgWithCategory ? TAG_TYPE.CATEGORY : TAG_TYPE.ORGANIZATION;
          tagKey = this.isUseOrgWithCategory ? this.projectSetupGeneral.org_category_key : undefined;
          isTagsMenuOpen = true;
      }
      this.$emit('menuType', TAG_TYPE.ORGANIZATION);
      this.$emit('updateTagsMenuData', isTagsMenuOpen, currentTagsType, false, '', tagKey, undefined, true, undefined);
    },
    toggleCategoriesTagMenu (overflow, category) {
      let currentTagsType;
      let isTagsMenuOpen;
      if(((this.isTagsMenuOverflow && overflow.enabled === this.isTagsMenuOverflow.enabled) || !this.isTagsMenuOverflow) && this.currentTagsType === TAG_TYPE.CATEGORY && !this.isTagsMenuPinned) {
        currentTagsType = '';
        isTagsMenuOpen = false;
      }
      else {
        currentTagsType = TAG_TYPE.CATEGORY;
        isTagsMenuOpen = true;
      }
      
      this.$emit('menuType', TAG_TYPE.CATEGORY);
      this.$emit('updateTagsMenuData', isTagsMenuOpen, currentTagsType, overflow, '', category, undefined, undefined, undefined);
    },
  },
  data () {
    return {
      CODING_TABS: CODING_TABS,
    }
  }
}
</script>

<style lang="scss">
@import "../../styles/components/coding-ui/sidebar";
</style>